var map = {
	"./1.png": 317,
	"./2.png": 318,
	"./3.png": 319,
	"./4.png": 320,
	"./5.png": 321,
	"./6.png": 322,
	"./Efficient.png": 323,
	"./Teams.png": 324,
	"./action_shap.png": 325,
	"./author_img.png": 326,
	"./banner_bg.png": 327,
	"./banner_img.png": 328,
	"./divider.png": 138,
	"./divider2.png": 329,
	"./dividerwhite.png": 139,
	"./dot.png": 330,
	"./icon01.png": 331,
	"./icon02.png": 332,
	"./icon3.png": 333,
	"./icon_04.png": 334,
	"./icon_05.png": 335,
	"./icon_how.png": 336,
	"./icon_shape1.png": 337,
	"./icon_shape2.png": 338,
	"./icon_shape3.png": 339,
	"./icon_shape4.png": 340,
	"./icon_what.png": 341,
	"./icon_who.png": 342,
	"./integration.png": 343,
	"./managment2.png": 344,
	"./multi1.png": 345,
	"./process_1.png": 346,
	"./process_2.png": 347,
	"./process_3.png": 348,
	"./process_4.png": 349,
	"./process_5.png": 350,
	"./quality.png": 351,
	"./shape.png": 352,
	"./team1.jpg": 353,
	"./team2.jpg": 354,
	"./work1.png": 355,
	"./work2.png": 356,
	"./work3.png": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;